module.exports = __webpack_public_path__ + "static/img/pic_06@2x.e06cb5c8.png";